export default class TopPosts {

  constructor(debug = false) {

    this.debug = debug;

    if (this.debug) console.log('TopPosts - init');

    if (this.setVars()) {
      if (this.debug) console.log('TopPosts - vars init done');
      this.setEvents();
    }
  }

  setVars()
  {
    this.offset           = 0;
    this.eventCount       = 0;
    this.eventWidth       = 0;
    this.eventWindowWidth = 0;
    this.offsetMax        = 0;
    this.textDirection    = getComputedStyle(document.querySelector('html')).direction;

    this.topPostsEl = document.querySelector('.jsTopPosts');
    if (!this.topPostsEl) return false;

    this.eventWindowEl = document.querySelector('[data-topposts-event-window]');
    if (!this.eventWindowEl) return false;

    this.eventTopPostsEl = document.querySelector('[data-topposts-event-topposts]');
    if (!this.eventTopPostsEl) return false;

    this.topPostsEventArr = this.topPostsEl.querySelectorAll('[data-topposts-event]');
    if (!this.topPostsEventArr.length) return false;

    this.topPostsButtonArr = this.topPostsEl.querySelectorAll('[data-topposts-button]');
    if (!this.topPostsButtonArr.length) return false;

    this.calcEventVars();

    return true;
  }

  setEvents()
  {
    if (this.debug) console.log('TopPosts - setting events');

    this.topPostsButtonArr.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.buttonClick(e.target);
      });
    });
  }

  calcEventVars()
  {
    this.eventCount       = this.topPostsEventArr.length;
    this.eventWidth       = this.topPostsEventArr[0].offsetWidth;
    this.eventWindowWidth = this.eventWindowEl.offsetWidth;
    this.offsetMax        = Math.max(this.eventCount - Math.floor(this.eventWindowWidth / this.eventWidth) - 1, 0);

    if (this.debug) console.log('eventCount / offsetMax', this.eventCount, this.offsetMax);
  }

  buttonClick(el)
  {
    if (this.debug) console.log('TopPosts - offset before', this.offset);

    switch (el.getAttribute('data-topposts-button')) {
    case 'left':
      this.recalculateOffsetLeft();
      break;

    case 'right':
      this.recalculateOffsetRight();
      break;

    default:
      if (this.debug) console.log('TopPosts - button click UNSUPPORTED');
    }

    if (this.textDirection === 'ltr') {
      this.eventTopPostsEl.style.transform = `translate3d(-${(this.offset * this.eventWidth)}px, 0, 0)`;
    } else {
      this.eventTopPostsEl.style.transform = `translate3d(${(this.offset * this.eventWidth)}px, 0, 0)`;
    }
  }

  recalculateOffsetLeft()
  {
    if (this.debug) console.log('TopPosts - moving left', this.offset);
    this.offset = (this.offset > 0) ? (this.offset - 1) : 0;
  }

  recalculateOffsetRight()
  {
    if (this.debug) console.log('TopPosts - moving right', this.offset, (this.offset <= this.offsetMax));
    this.offset = this.offset <= this.offsetMax ? (this.offset + 1) : this.offset;
  }
}
